// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e28aa03","455":"43229139","977":"fab70edc"}[chunkId] + ".chunk.js";
};